import { DeviceType, ToggleDeviceButtonGroup } from "./ToggleDeviceButtonGroup"

import { DesignerMode } from "../../../../types"
import { FC } from "react"
import { PageViewButtonGroup } from "./PageViewButtonGroup"

interface IPageControlsToolbarProps {
    editMode: DesignerMode,
    onEditModeChange: (type: DesignerMode) => void
    deviceType: DeviceType,
    onDeviceTypeChange: (type: DeviceType) => void
}

export const PageControlsToolbar: FC<IPageControlsToolbarProps> = ({
    editMode,
    onEditModeChange,
    deviceType,
    onDeviceTypeChange
}) => {
    return <>
        <div className='d-flex flex-wrap bg-dark w-100 h-30px px-2 gap-5'>
            <PageViewButtonGroup
                groupName="page-controls"
                type={editMode}
                onChange={onEditModeChange} />
            <div className='flex-fill'></div>
            <ToggleDeviceButtonGroup
                groupName="page-controls-device-buttons"
                type={deviceType}
                onChange={onDeviceTypeChange} />
        </div>
    </>
}

